// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{ name: NonNullable<unknown> }} i
*/
export const guestList_deleteGuestWithWaitlistInfo = (i) => `ℹ️ Der nächste Gast auf der Warteliste rückt automatisch nach. ℹ️

Willst du "${i.name}" wirklich entfernen?`